import { createFileRoute } from "@tanstack/react-router";
import { StartUpDataContextProvider } from "src/contexts/StartUpDataContextProvider.tsx";
import { CustomUiActionsContextProvider } from "src/components/common/customUiActions/CustomUiActionsContextProvider.tsx";
import { ViewCatalogContextProvider } from "src/routing/viewCatalog/ViewCatalogContextProvider.tsx";
import { AgentUiContextProvider } from "src/components/views/ai/assistant/uiContext/AgentUiContextProvider.tsx";
import { ConnectedCustomAppsContextProvider } from "src/customApps/ai/ConnectedCustomAppsContextProvider.tsx";
import { ErrorDialogContextProvider } from "src/components/common/dialogs/errorDialog/ErrorDialogContextProvider.tsx";
import { AiAssistantControllerContextProvider } from "src/components/views/ai/assistant/AiAssistantControllerContextProvider.tsx";
import { QrCodeModalContextProvider } from "src/components/common/qrCode/QrCodeModalContextProvider.tsx";
import { BackgroundOperationsContextProvider } from "src/components/views/backgroundOperations/BackgroundOperationsContextProvider.tsx";
import { GenericDialogContextProvider } from "src/components/common/dialogs/GenericDialogContextProvider.tsx";
import { AiAssistantPortal } from "src/components/views/ai/assistant/AiAssistantPortal.tsx";
import { ErrorDialogHost } from "src/components/common/dialogs/errorDialog/ErrorDialogHost.tsx";
import { MainPage } from "src/components/views/main/MainPage.tsx";
import { PageNotFound } from "src/components/common/PageNotFound.tsx";
import { KeptAliveViewsOutlet } from "src/routing/keepAlive/KeptAliveViewsOutlet.tsx";
import { useActiveViewState } from "src/routing/keepAlive/activeView.ts";

/** The main application with the main menu. Its child routes with a view key are the main menu views. */
export const Route = createFileRoute("/_authenticated/_shell")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<StartUpDataContextProvider>
			<CustomUiActionsContextProvider>
				<ViewCatalogContextProvider>
					<AgentUiContextProvider>
						<ConnectedCustomAppsContextProvider>
							<ErrorDialogContextProvider>
								<AiAssistantControllerContextProvider>
									<QrCodeModalContextProvider>
										<BackgroundOperationsContextProvider>
											<GenericDialogContextProvider>
												<ShellContent />
												<AiAssistantPortal />
											</GenericDialogContextProvider>
										</BackgroundOperationsContextProvider>
										<ErrorDialogHost />
									</QrCodeModalContextProvider>
								</AiAssistantControllerContextProvider>
							</ErrorDialogContextProvider>
						</ConnectedCustomAppsContextProvider>
					</AgentUiContextProvider>
				</ViewCatalogContextProvider>
			</CustomUiActionsContextProvider>
		</StartUpDataContextProvider>
	);
}

function ShellContent() {
	const { isUnavailableView } = useActiveViewState();
	if (isUnavailableView) return <PageNotFound />;
	return (
		<MainPage>
			<KeptAliveViewsOutlet />
		</MainPage>
	);
}
